import React, { useEffect, useRef } from 'react';
import { Backdrop } from "../../index";
import './tooltip.scss';

export const TooltipSpotlight = ({
    tooltip,
    open,
    placement,
    linkOnClick = () => { },
    scrollIntoView
}) => {

    const spotlightRef = useRef();

    // Scroll element into window view not scrolling within another element
    // Using scrollTo instead of scrollIntoView for better Safari support
    const scrollIntoWindowView = (id, el, behavior, offSet) => {
        let element = document.querySelector(id) || el;
        let animateBehavior = behavior ? behavior : "smooth";
        const topOffset = offSet ? offSet : -200;

        if (element && window) {
            const scrollY = element.getBoundingClientRect().top + window.pageYOffset + topOffset;
            window.scrollTo({ top: scrollY, behavior: animateBehavior });
        }
    }

    useEffect(() => {
        if (open && scrollIntoView) {
            const spotlightRefContent = spotlightRef && spotlightRef?.current && spotlightRef?.current?.children[0] ? spotlightRef.current.children[0] : null;
            const alignBottom = placement && placement.toLowerCase().indexOf("bottom") !== -1 ? true : false;
            let tooltipEl = spotlightRefContent && spotlightRefContent.children[0] ? spotlightRefContent.children[0] : null;
            let childrenEl = spotlightRefContent && spotlightRefContent.children[1] ? spotlightRefContent.children[1] : null;
            let scrollEl = alignBottom ? childrenEl : tooltipEl;
            let winHeight = window && window.innerHeight ? window.innerHeight : 0;

            if (scrollEl && tooltipEl && childrenEl) {
                const tooltipScrollTimeOut = setTimeout(() => {
                    let tooltipRect = tooltipEl.getBoundingClientRect();
                    let childrenRect = childrenEl.getBoundingClientRect();
                    let isTooltipInView = true;

                    if (alignBottom) {
                        isTooltipInView = tooltipRect && childrenRect.top > -1 && tooltipRect.bottom <= winHeight ? true : false;
                    } else {
                        isTooltipInView = tooltipRect && tooltipRect.top > -1 && childrenRect.bottom <= winHeight ? true : false;
                    }

                    if (!isTooltipInView) {
                        scrollIntoWindowView(null, scrollEl);
                    }
                }, 500);

                return () => clearTimeout(tooltipScrollTimeOut);
            }
        }
    }, [open]);

    return (<>
                {open && <Backdrop onClick={linkOnClick} />}
                <div
                    className={`bsw-tooltip__child ${open ? 'bsw-tooltip-show' : ''}`}
                    ref={spotlightRef}
                >
                    {tooltip}
                </div>
            </>
    );
}
